import React from "react";
import FormInput from "../FormInput";

export const EXPIRY_DAYS_REQUIRED_MESSAGE = "Expiry Days is required.";
export const EXPIRY_DAYS_POSITIVE_MESSAGE =
  "Expiry Days must be a positive number.";

export function normalizeExpiryDaysValue(value) {
  const digits = String(value ?? "").replace(/\D/g, "");
  return digits ? Number(digits) : "";
}

export function validateExpiryDays(value, { required = true } = {}) {
  const normalizedValue = normalizeExpiryDaysValue(value);

  if (normalizedValue === "") {
    return required ? EXPIRY_DAYS_REQUIRED_MESSAGE : "";
  }

  if (Number(normalizedValue) <= 0) {
    return EXPIRY_DAYS_POSITIVE_MESSAGE;
  }

  return "";
}

export function withExpiryDaysPayload(payload, key = "DaysToExpire") {
  const expiryDaysValue = normalizeExpiryDaysValue(payload?.[key]);
  const nextPayload = { ...payload };

  if (expiryDaysValue === "") {
    delete nextPayload[key];
    return nextPayload;
  }

  return {
    ...nextPayload,
    [key]: expiryDaysValue,
  };
}

export default function ExpiryDaysInput({
  error = "",
  label = "Transaction will expire in (days)",
  name = "DaysToExpire",
  onChange,
  onClearError,
  placeholder = "Expiry Days",
  required = false,
  value = "",
  ...props
}) {
  return (
    <FormInput
      {...props}
      type="text"
      name={name}
      label={required ? `${label} *` : label}
      aria-required={required}
      aria-invalid={Boolean(error)}
      value={value ?? ""}
      error={error}
      placeholder={placeholder}
      autoComplete="off"
      inputMode="numeric"
      pattern="[0-9]*"
      onChange={(event) => {
        onChange?.(normalizeExpiryDaysValue(event.target.value), event);
        onClearError?.();
      }}
    />
  );
}
